



















// import OtDocumentList from '@/components/documents/document-list/ot-document-list.vue';
import OtDocumentsFilter from '@/components/documents/document-list/ot-documents-filter.vue';
import { DocumentListLevel, DocumentListMode, DocumentsFilter } from '@/components/documents/document-models';
import OtStandardHeaderArchetype from '@/components/global/archetypes/ot-standard-header-archetype.vue';

import { Component, Vue } from 'vue-property-decorator';
@Component({
  components: {
    OtDocumentList: () => import('@/components/documents/document-list/ot-document-list.vue'),
    OtDocumentsFilter,
    OtStandardHeaderArchetype,
  },
})
export default class OtDocumentsIndex extends Vue {
  // * PROPS

  // * REFS

  // * DATA
  private filters: DocumentsFilter | null = null;
  private level = DocumentListLevel.Global;
  private mode = DocumentListMode.Display;

  // * METHODS
  private handleFilterUpdate(nextFilter: DocumentsFilter) {
    this.filters = nextFilter;
  }

  // * METHODS

  // * LIFECYCLE
}
